const modules = document.querySelectorAll('[data-module]');
const observer = new IntersectionObserver(items =>
    items.forEach(e => {
        if (e.isIntersecting) {
            import(`./modules/${e.target.dataset.module}.js`).then(mod => mod.default(e.target));
            observer.unobserve(e.target);
        }
    }),
);
modules.forEach(module => observer.observe(module));

import './common';
